import { ContainerProps } from '@my/ui'
import { NavCarouselItem } from './nav-carousel-item'
import { NavCarouselItems } from './nav-carousel-items'

export type NavCarouselProps = {
  items: NavCarouselItem[]
  currentSelectedItem?: NavCarouselItem
}

export const NavCarousel = ({ items, currentSelectedItem }: NavCarouselProps & ContainerProps) => {
  if (items?.length === 0) return null
  return <NavCarouselItems items={items} currentSelectedItem={currentSelectedItem} />
}
